/* src/app/profile-landing/profile-landing.component.css */
/*# sourceMappingURL=profile-landing.component.css.map */
